/**
 * Renders a translated string with lightweight inline markup, so message
 * catalogs can carry emphasis without JSX: **bold**, *italic*, and `code`.
 */
const TOKEN = /(`[^`]+`|\*\*[^*]+\*\*|\*[^*]+\*)/g

export function RichText({ text }: { text: string }) {
  return (
    <>
      {text.split(TOKEN).map((part, i) => {
        if (part.startsWith("`") && part.endsWith("`") && part.length > 2) {
          return (
            <code key={i} className="bg-muted rounded px-1 py-0.5 text-xs">
              {part.slice(1, -1)}
            </code>
          )
        }
        if (part.startsWith("**") && part.endsWith("**") && part.length > 4) {
          return (
            <strong key={i} className="text-foreground font-medium">
              {part.slice(2, -2)}
            </strong>
          )
        }
        if (part.startsWith("*") && part.endsWith("*") && part.length > 2) {
          return <em key={i}>{part.slice(1, -1)}</em>
        }
        return part
      })}
    </>
  )
}
